import React from 'react'
import { ArrowForward } from '@mui/icons-material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import BrandBandWaves from './decorations/BrandBandWaves'

const SMARTPM_URL = 'https://smartpm.es/'

/**
 * Closing brand band: the platform message that rounds off the landing, with the
 * catch-all link to the SMARTPM website.
 *
 * The headline is two independent sentences, kept as two keys so the two-line
 * treatment of the reference design survives translation.
 */
const BrandBand = () => {
  const { t_ } = useSmartTranslation()

  return (
    <section className='mic-home-band'>
      <div className='mic-home-band-frame'>
        <BrandBandWaves />
        <div className='mic-home-band-glow' />
        <div className='mic-home-band-body'>
          <div className='mic-home-band-eyebrow'>MIC · Industry | Future</div>
          <div className='mic-home-band-title'>
            <div>{t_('One platform.')}</div>
            <div>{t_('Your entire industrial operation.')}</div>
          </div>
          <p className='mic-home-band-text'>
            {t_('From the shop floor to management: projects, production, support and data, connected in real time.')}
          </p>
          <a
            className='mic-home-cta mic-home-cta-ghost'
            href={SMARTPM_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t_('Discover everything MIC can do')}
            <ArrowForward />
          </a>
        </div>
      </div>
    </section>
  )
}

export default BrandBand
